import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cms-job-case",
  "use": "icon-cms-job-case-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cms-job-case\"><path d=\"M834.221 448.216v-243.27H537.582v-79.243H277.687l-87.377 76.619v245.895h-63.142v342.375c0 57.962 47.916 105.117 106.812 105.117H791.14c58.897 0 106.814-47.155 106.814-105.117V448.216H834.22z m-51.165-192.104v192.104h-47.017V256.112h47.017z m-98.183 0v192.104H636.25V256.112h48.623z m-146.805 0h47.017v192.104h-47.017V256.112z m-296.592-30.607l0.458-0.401h55.443v-48.237h189.04v271.35h-244.94V225.504z m605.312 565.086c0 29.749-24.964 53.952-55.648 53.952H233.982c-30.684 0-55.648-24.202-55.648-53.952v-291.21h668.453v291.21z\" p-id=\"3605\" fill=\"#b5c5d2\" /><path d=\"M353.52 751.962h318.083V591.963H353.52v160z m51.165-108.833h215.752v57.668H404.685v-57.668z\" p-id=\"3606\" fill=\"#b5c5d2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cms-job-case.svg
// module id = I3Jr
// module chunks = 59